import React, { useState } from "react";
import { Dialog, DialogTitle, DialogContent, DialogActions, Tabs, Tab, Typography, Box, Paper, Button } from "@mui/material";
import { makeStyles } from "@mui/styles";

const useStyles = makeStyles((theme) => ({
    list:{
        paddingLeft: 3, mt: 1, fontFamily:'sans-serif',
        '& li':{
            padding: '0.7rem',
            background:'#eee',
            marginBottom:'10px'
        },
    },
}));

function DomainVerificationPopup({ open, onClose, onVerify, url }) {
  const [activeTab, setActiveTab] = useState(0);
  const classes = useStyles();
  return (
    <Dialog open={open} onClose={onClose} fullWidth maxWidth="md">
      <DialogTitle sx={{ fontWeight: "bold", borderBottom: "1px solid #ddd" }}>
      Verify Domain Ownership
        
      </DialogTitle>
      <DialogContent>
      <Tabs value={activeTab} onChange={(e, value) => setActiveTab(value)} indicatorColor="primary" textColor="primary">
          <Tab label="DNS Verification" sx={{ fontWeight: activeTab === 0 ? "bold" : "normal" }} />
          <Tab label="HTML File Upload" sx={{ fontWeight: activeTab === 1 ? "bold" : "normal" }} />
        </Tabs>
        {activeTab === 0 ? (
          <Paper sx={{ padding: 2 }}>
            <Typography>
              Add a DNS TXT record to your domain host to prove that you own the domain. Most domain hosts allow this, but the specific steps for each service may vary. If you need help, please contact your domain host’s support team or check their documentation.
            </Typography>
            <Typography variant="h6" sx={{ mt: 2, fontWeight: "bold" }}>
              DNS TXT Record
            </Typography>
            <Typography sx={{ mt: 1 }}>Here are the basic steps:</Typography>
            <Box component="ol" className={classes.list}>
              <li>Login to your domain registrar and visit the DNS records section.</li>
              <li>
                Add this TXT record in your DNS configuration:{" "}
                <Box component="span" sx={{ fontWeight: "bold" }}>
                  facebook-domain-verification=nwf1p147ltwano67u8m1rh7bx8hmxv
                </Box>
              </li>
              <li>Add @ in the Host field (if your domain host requires it).</li>
              <li>Wait until your DNS configuration changes have spread across your website's domain servers (this may take up to 72 hours), then click Verify.</li>
            </Box>
          </Paper>
        ) : (
          <Paper sx={{ padding: 2 }}>
            <Typography>
              Upload an HTML verification file to your website. To do this, you need admin access to your website’s root folder. This will verify your domain immediately.
            </Typography>
            <Typography variant="h6" sx={{ mt: 2, fontWeight: "bold" }}>
              HTML File Upload
            </Typography>
            <Typography sx={{ mt: 1 }}>Here are the basic steps:</Typography>
            <Box component="ol" className={classes.list}>
              <li>
                Download the{" "}
                <a href="#" style={{ color: "blue", textDecoration: "underline" }}>
                  HTML verification file
                </a>
                .
              </li>
              <li>
                Upload this file to the root directory of{" "}
                <Box component="span" sx={{ fontWeight: "bold", color: "blue" }}>
                  {url}
                </Box>
              </li>
              <li>
                Confirm that it’s uploading by visiting{" "}
                <Box component="span" sx={{ fontWeight: "bold", color: "blue" }}>
                  {url}/nwf1p147ltwano67u8m1rh7bx8hmxv.html
                </Box>
              </li>
              <li>Click Verify.</li>
            </Box>
          </Paper>
        )}
      </DialogContent>
      <DialogActions sx={{ padding: "16px" }}>
        <Button
          onClick={() => {
            onVerify();
            onClose();
          }}
          variant="contained"
          color="success"
          sx={{ fontWeight: "bold" }}
        >
          Verify
        </Button>
      </DialogActions>
    </Dialog>
  );
}

export default DomainVerificationPopup;
